import * as z from "zod";

import { propertyPartSchema } from "./property-part";
import { propertySchema } from "./property";

export const propertyPartWithPropertySchema = propertyPartSchema.extend({
  property: propertySchema,
});

export type PropertyPartWithProperty = z.infer<
  typeof propertyPartWithPropertySchema
>;
